import commonFunc from '@/components/monitoring/common/CommonFunction';

class defaultEntity {
    constructor(page, size) {
        this.page = page;
        this.size = size;
    }

    get() {
        return {
            page: String(this.page),
            size: String(this.size)
        }
    }
}

class MainEntity {
    constructor(startDate, endDate, keyTable, keyWord, page, size, officeid, appId) {
        this.startDate = commonFunc.dateSetSecondWithT(startDate);
        this.endDate = commonFunc.dateSetSecondWithT(endDate);
        this.keyTable = keyTable;
        this.keyWord = keyWord;
        this.page = page;
        this.size = size;
        this.officeid = officeid;
        this.appId = appId;
    }

    get() {
        return {
            startDate: this.startDate,
            endDate: this.endDate,
            keyTable: this.keyTable,
            keyWord: this.keyWord,
            page: String(this.page),
            size: String(this.size),
            officeid: this.officeid,
            appId: this.appId
        }
    }
}

class Region extends defaultEntity {
    result(response) {
        return response.data.content.map(element => {
            return {
                regionId: element.regionId,
                regionName: element.regionName,
                description: element.description,
            }
        })
    }
}

class DrivingRoute {
    constructor(officeId, carNum, driverId, orders, payType, page, size, startDate, endDate, routeType, viewYn) {
        this.officeId = officeId
        this.carNum = carNum
        this.driverId = driverId
        this.orders = orders
        this.payType = payType
        this.page = page
        this.size = size
        this.startDate = startDate
        this.endDate = endDate
        this.routeType = routeType
        this.viewYn = viewYn
    }

    get() {
        return {
            officeId: this.officeId,
            carNum: this.carNum,
            driverId: this.driverId,
            orders: this.orders,
            payType: this.payType,
            page: this.page,
            size: this.size,
            startDate: this.startDate,
            endDate: this.endDate,
            routeType: this.routeType,
            viewYn: this.viewYn
        }
    }
}

const entity = {
    defaultEntity,
    MainEntity,
    Region,
    DrivingRoute,
}

export default entity